(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.SouvenirCoasterCartModel=factory();})(typeof globalThis==='object'?globalThis:this,function(){
'use strict';
// OFFLINE PILOT MODEL. No network calls and no Shopify mutations.
// Prices are real pack-variant totals, never a client-only discount.
const PRICE_CENTS = Object.freeze({1:1799,2:2879,4:4139,6:4949,8:6299,10:7109,15:8999,25:14669,50:24299,75:33929,100:43559});
const PACK_SIZES = Object.freeze(Object.keys(PRICE_CENTS).map(Number));
function total(size) {
  if (!Number.isSafeInteger(size) || !Object.hasOwn(PRICE_CENTS, size)) throw Error('Choose one of the listed coaster pack sizes.');
  return PRICE_CENTS[size];
}
function normalize(selection, catalog) {
  if (!Array.isArray(selection)) throw Error('Review your coaster designs.');
  const known = new Map(catalog.map(d => [d.id,d]));
  const counts = new Map();
  for (const s of selection) {
    if (!s || typeof s.id !== 'string' || !known.has(s.id) || s.id.includes('|') || !Number.isSafeInteger(s.quantity) || s.quantity < 1 || s.quantity > 100) throw Error('Review your coaster designs and quantities.');
    counts.set(s.id, (counts.get(s.id) || 0) + s.quantity);
  }
  const entries = [...counts].sort(([a],[b]) => a.localeCompare(b)).map(([id,quantity]) => ({id,quantity}));
  if (entries.reduce((n,s) => n + s.quantity,0) > 100) throw Error('Each coaster pack can contain at most 100 coasters.');
  return entries;
}
function token(value) {
  if (typeof value !== 'string' || !/^[A-Za-z0-9_-]{1,100}$/.test(value)) throw Error('Missing pack identity.');
  return value;
}
function variantFor(size, variants) {
  const matches = variants.filter(v => v.sku === `COAST-MIX-P${size}`);
  const v = matches[0];
  if (matches.length !== 1 || !v.available || !Number.isSafeInteger(Number(v.id)) || Number(v.id) <= 0 || !Number.isSafeInteger(v.price) || v.price !== total(size)) throw Error('Coaster ordering is being prepared. Please try again later.');
  return v;
}
function planPack({size,selection,packId,transaction}, catalog, variants) {
  const expected = total(size), normalized = normalize(selection,catalog);
  if (normalized.reduce((n,s) => n+s.quantity,0) !== size) throw Error('Fill the selected coaster pack before adding it.');
  const v = variantFor(size, variants), known = new Map(catalog.map(d=>[d.id,d]));
  const properties = {'Pack size':String(size), 'Design count':String(normalized.length), _coaster_version:'1', _coaster_pack:token(packId), _coaster_transaction:token(transaction)};
  normalized.forEach((s,i) => { const d=known.get(s.id); properties[`Design ${i+1}`]=`${s.id} | ${s.quantity} | ${String(d.label || d.title || d.id).slice(0,150)}`; });
  return {items:[{id:Number(v.id), quantity:1, properties}], expected, size, selection:normalized};
}
function readCart(cart,catalog,config) {
  const packs=[],lines=[],others=[],invalid=[]; const seen=new Set(); let expected=0,coasterCount=0;
  for (const item of cart.items) {
    if (String(item.product_id) !== String(config.productId)) { others.push(item); continue; }
    lines.push(item);
    try {
      const properties=item.properties || {}, size=Number(properties['Pack size']), designs=Number(properties['Design count']);
      if (!Number.isSafeInteger(designs) || designs < 1 || designs > size || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || properties._coaster_version !== '1') throw Error('Invalid coaster pack.');
      const packId=token(properties._coaster_pack); token(properties._coaster_transaction);
      if (seen.has(packId)) throw Error('Duplicate pack identity.');
      const chosen=[];
      for(let i=1;i<=designs;i++) {
        const match=/^([^|]+) \| ([1-9][0-9]*) \| (.*)$/s.exec(properties[`Design ${i}`] || '');
        if (!match) throw Error('Missing coaster selection.');
        chosen.push({id:match[1],quantity:Number(match[2])});
      }
      if (Object.keys(properties).filter(k=>/^Design [0-9]+$/.test(k)).length !== designs) throw Error('Unexpected design entries.');
      const selected=normalize(chosen,catalog), v=variantFor(size,config.variants);
      if (selected.length !== chosen.length || selected.reduce((n,s)=>n+s.quantity,0) !== size || String(item.variant_id ?? item.id) !== String(v.id) || item.sku !== v.sku || item.original_price !== total(size) || item.selling_plan_allocation) throw Error('Coaster pack details or price changed.');
      const amount=total(size)*item.quantity, count=size*item.quantity;
      if (!Number.isSafeInteger(amount) || !Number.isSafeInteger(count) || !Number.isSafeInteger(expected+amount) || !Number.isSafeInteger(coasterCount+count)) throw Error('Coaster quantity exceeds safe range.');
      seen.add(packId); expected+=amount; coasterCount+=count;
      packs.push({key:item.key,packId,size,quantity:item.quantity,selection:selected,expected:amount});
    } catch (error) { invalid.push({item,reason:error.message}); }
  }
  return {packs,lines,others,invalid,expected,coasterCount};
}
function identity(item) {
  return JSON.stringify([String(item.variant_id ?? item.id),Object.entries(item.properties || {}).sort(([a],[b])=>a.localeCompare(b)),String(item.selling_plan_allocation?.selling_plan?.id || '')]);
}
return {PRICE_CENTS,PACK_SIZES,total,normalize,planPack,readCart,identity};
});
